import { render, staticRenderFns } from "./dybqDialog.vue?vue&type=template&id=5e84c01e&"
import script from "./dybqDialog.vue?vue&type=script&lang=js&"
export * from "./dybqDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports